import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from '@mui/material/Tooltip';
import MuiTableCell from '@mui/material/TableCell';
import { useEffect, useMemo, useRef } from 'react';
import { getColumnWidth } from '../constants/defaultColumnsWidth';
import { useMaxColumnWidth, useSetMaxColumnWidth } from '../ColumnWidthsContext';
import { useUserColumnWidth } from '../UserColumnWidthsContext';
import { cellStyle } from '../styles';
import { useSTRows } from '../SmartTableContext';
export function TableBodyCellWithData({ row, column, columnIndex }) {
    const { rowsSelectEnabled } = useSTRows();
    const renderResult = useMemo(() => column.bodyCellRenderer(row, column), [column, row]);
    const hasShape = (r) => !!r && typeof r === 'object' && ('node' in r || 'value' in r);
    const node = hasShape(renderResult) ? renderResult.node ?? renderResult.value : renderResult;
    const value = hasShape(renderResult) ? renderResult.value : renderResult;
    const hasValue = value != null && value !== '';
    const maxWidth = useMaxColumnWidth(column.fieldName);
    const userWidth = useUserColumnWidth(column.fieldName);
    const width = getColumnWidth(column.fieldName, column.format, maxWidth, userWidth);
    const setColumnWidth = useSetMaxColumnWidth(column.fieldName);
    const isIndex = columnIndex === 0;
    const isIpsosId = columnIndex === 1;
    const isSticky = columnIndex < 2;
    const isLastSticky = isIpsosId;
    const checkboxColWidth = 40;
    const indexColWidth = 56;
    const stickyBaseLeft = rowsSelectEnabled ? checkboxColWidth : 0;
    const stickyLeft = isIndex ? stickyBaseLeft : stickyBaseLeft + indexColWidth;
    const ref = useRef();
    useEffect(() => {
        const el = ref.current;
        if (!el || width !== undefined) {
            return;
        }
        setColumnWidth(el.offsetWidth);
    }, [setColumnWidth, width]);
    return (_jsx(MuiTableCell, { ref: ref, sx: {
            ...cellStyle,
            width,
            minWidth: width,
            maxWidth: width,
            ...(isSticky
                ? {
                    position: 'sticky',
                    left: stickyLeft,
                    zIndex: 5,
                    backgroundColor: 'inherit',
                    borderBottom: '1px solid',
                    borderBottomColor: 'divider',
                    ...(isLastSticky
                        ? {
                            borderRight: '1px solid',
                            borderColor: 'divider',
                        }
                        : {}),
                }
                : {}),
        }, children: hasValue ? (_jsx(Tooltip, { title: _jsx("span", { children: value }), children: _jsx("span", { children: node }) })) : null }, `table-cell-${row.id}-${column.fieldName}-cell`));
}
//# sourceMappingURL=TableBodyCellWithData.js.map